import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/tab/Room/Views/room-info-edit.html";
import Spinner from "@/Pages/Admin/Modules/Common/Controllers/Spinner";
import GeneralStore from "@/Pages/Admin/Modules/Hotel/Store/General";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";

import {RoomModel} from '@/Pages/Admin/Modules/Models/Hotel/RoomModel';
import { HotelModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelModel";
import {hotelService} from "@/Pages/Admin/Modules/Hotel/Services/HotelService"

@WithRender
@Component({
  components: {
    Spinner,
    "validation-error": ValidationError
  }
})
export default class RoomEdit extends Vue {
  protected ui: any = {};
  protected item: any = {};
  protected status: any = {};

  constructor() {
    super();
    this.status.Edit = false;

    this.ui = {
      index: {
        edit: -1,
        isEdit: false,
        delete: -1,
        up: 0,
        down: 0
      },
      status: {
        isLoading: {
          roomList: false,
        },
        postLoading: {
          roomList: false,
        },
        canAdd: false
      },
      error: {
        errors: [],
        validationErrors: {},
        hasError: false
      }
    };
    this.item = {
         hotelId: 0,
         roomId:0,
      roomList: new RoomModel({}),
      editRoom: new RoomModel({}),
    };
  }

  public beforeMount() {
    this.item.hotelId = this.$route.query.id;
  }

  public mounted() {
    this.getRoom();
  }



  protected getRoom() {
    this.ui.IsLoading = true;
    const data = {
      hotel_id: this.item.hotelId,
      room_id:this.$route.query.rid
    };
    hotelService
      .getRoomInfo(data)
      .then((res: any) => {
        this.ui.IsLoading = false;
        this.item.roomList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.IsLoading = false;
      });
  }


  public get buttonName() {
    if (this.ui.PostLoading) {
      return "Processing...";
    }
    return "Update";
  }

  protected updateInfo() {
    this.ui.error.validationErrors = {};
    this.ui.error.errors = [];
    this.ui.error.hasError = false;

    if (!this.IsValidationTrue()) {
      return;
    }
    this.ui.status.postLoading.roomList = true;
    const data = {
      hotel_id: this.item.hotelId,
      room_id: this.$route.query.rid,
      room_type: this.item.roomList.room_type,
      bed_type: this.item.roomList.bed_type,
      is_smoking: this.item.roomList.is_smoking,
      is_free_parking: this.item.roomList.is_free_parking,
      adult: Number(this.item.roomList.adult),
      child: Number(this.item.roomList.child),
      total_room: Number(this.item.roomList.total_room),
      total_size: this.item.roomList.total_size,
      breadth: this.item.roomList.breadth,
      length: this.item.roomList.length,
    };
    hotelService
      .updateRoomInfo(data)
      .then((res: any) => {
       this.$router.push({
                    name: 'create-business-hotel-room',
                    query: {
                         id: this.item.hotelId,
                    },
                });
        flashService.Success("Room info update", res.data.message);
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.hotelList = false;
        this.status.Edit = false;
      });
  }



  protected IsValidationTrue() {
   if (!this.item.roomList.room_type) {
      Object.assign(this.ui.error.validationErrors, {
        room_type: ["The room type field is required."]
      });
    }
    if (!this.item.roomList.bed_type) {
      Object.assign(this.ui.error.validationErrors, {
        bed_type: ["The bed type field is required."]
      });
    }

    if (!this.item.roomList.total_room) {
      Object.assign(this.ui.error.validationErrors, {
        total_room: ["The total room  field is required."]
      });
    }
    if (!this.item.roomList.adult) {
      Object.assign(this.ui.error.validationErrors, {
        adult: ["The adult field is required."]
      });
    }

    if (common.notEmpty(this.ui.error.validationErrors)) {
      this.ui.error.hasError = true;
      return false;
    } else {
      return true;
    }
  }

  protected editRoom() {
    this.status.Edit = true;
    this.item.editRoom = Object.assign({}, new RoomModel({}));
    this.item.editRoom = Object.assign({}, this.item.roomList);
  }

  protected cancelRoomUpdate() {
    this.status.Edit = false;
    this.ui.error.errors = [];
    this.ui.error.validationErrors = {};
    this.ui.error.hasError = false;
    this.item.roomList = this.item.roomList;
  }

  protected hideIcon() {
    $(".informative-block").hide();
  }

  public cancleEditRoomInfo(item: any) {
        this.$router.push({
            name: 'create-business-hotel-room',
                    query: {
                         id: this.item.hotelId,
                    },
        });
  }
  
}
